import { createContext } from 'react';

const adoptionContext = createContext();

export default adoptionContext;
